import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers/yup';

import { getAccessByPropPath } from 'common/utils/errorObject';

import { FeesConfigurationSchema } from 'common/components/Steps/TrialMembershipStep/ValidationSchema';

import { IEditablePackageConfiguration } from 'common/interfaces/membership';

import { DialogComponent } from 'common/components/index';

import packagesMessages from 'modules/services/messages/packages';
import FeeInstance from './FeesSection/FeeInstance';
import { IPackageFee } from '../../../../../modules/services/interfaces/packages';

// TODO - PRM-1810 tmp form interface
interface IFormValues {
  fees: IPackageFee[];
}

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (packageItem: any) => void;
  membershipPackage: IEditablePackageConfiguration | null;
}

const EditFeesModal = ({ isOpen, onClose, onSubmit, membershipPackage }: IProps): JSX.Element => {
  const formMethods = useForm<IFormValues>({
    defaultValues: { fees: [] },
    resolver: yupResolver(FeesConfigurationSchema) as any, // TODO - PRM-1810 need resolver type
    mode: 'onBlur',
    shouldUnregister: false,
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = formMethods;

  useEffect(() => {
    reset({ fees: membershipPackage?.feeSection?.fees });
  }, [membershipPackage, reset]);

  const handleSubmitForm = formValues => {
    onSubmit({
      ...membershipPackage,
      feeSection: { ...membershipPackage?.feeSection, ...formValues },
    });
  };

  return (
    <DialogComponent
      isOpen={isOpen}
      onClose={onClose}
      title={<FormattedMessage {...packagesMessages.editFeesModalTitle} />}
      onSubmit={handleSubmit(handleSubmitForm)}
    >
      <FormProvider {...formMethods}>
        <form>
          <Grid container spacing={2}>
            {membershipPackage?.feeSection?.fees.map((feeItem, index) => (
              <Grid item xs={12}>
                <FeeInstance
                  key={feeItem.id}
                  formName={`fees.${index}`}
                  packageFee={feeItem}
                  errors={getAccessByPropPath(errors, `fees.${index}`)}
                />
              </Grid>
            ))}
          </Grid>
        </form>
      </FormProvider>
    </DialogComponent>
  );
};

export default EditFeesModal;
